import React from 'react';
import { useUser } from '../context/UserContext';
import { getEntitlements } from '../utils/entitlements';
import { FaCrown } from 'react-icons/fa';
import './AdBanner.css';

/**
 * Ad slot for free-tier users. Renders nothing for pre_alpha and pro tiers.
 *
 * Currently shows a house ad (Pro upsell). When a real ad network is
 * integrated, this component is the single place to mount it.
 */
const AdBanner = ({ placement = 'default' }) => {
  const { state } = useUser();
  const entitlements = getEntitlements(state.user);

  if (!entitlements.showAds) return null;

  return (
    <div className={`ad-banner ad-banner-${placement}`}>
      <span className="ad-banner-tag">Ad</span>
      <div className="ad-banner-body">
        <FaCrown className="ad-banner-icon" />
        <div>
          <strong>Go Pro, lose the ads.</strong>
          <span> Unlock the Game of Life simulator and interactive workshops.</span>
        </div>
      </div>
    </div>
  );
};

export default AdBanner;
